import { _ } from "libs";

import React, { useEffect, useContext, useState } from "react";
import ReservationPageContext from "./reservationPageContext";
import SubPageLayout from "./subPageLayout";
import cx from "classnames";
import { displayCardNetwork } from "../../../actions/helpers";

const PaymentNetworkSelect = () => {
	const pageContext = useContext(ReservationPageContext);
	const {
		reservation: { cards, context, params, selectedCard, selectedNetwork, networks },
		goBack,
		selectPaymentNetwork,
	} = pageContext;

	const cellClassName = (selectedCell: boolean) => {
		return cx("cell selectableCell", { selectedCell });
	};

	return (
		<SubPageLayout title={_("bookingWizard.paymentNetwork.heading")} extraClass="selectPaymentMethod">
			<div className="wizardBody">
				<div className="table dominantLabels">
					{networks.map((option) => {
						return (
							<div
								key={option}
								className={cellClassName(option === selectedNetwork)}
								onClick={() => {
									selectPaymentNetwork(option);
									goBack();
								}}
							>
								<div className="tableRow">
									<div className="tableRowIcon" />
									<div className="tableRowValue horizontal">
										<div className="creditCardEnding">{displayCardNetwork(option)}</div>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</SubPageLayout>
	);
};

export default PaymentNetworkSelect;
